<template>
  <div class="view_bg">
    <img src="//images.weelv.com/static/icon/emailhome.png" class="bg_image">
    <img src="//images.weelv.com/static/icon/logo.png" class="logo_image">
    <div class="panel">
      <div class="title web-font">岛屿天气</div>
      <div class="info">
        <div class="sign_info web-font">“</div>
        <span>马尔代夫150+岛，各岛实时天气</span>
        <span>独家数据，分钟级精确</span>
<!--        <span style="color:#e0c774; font-weight:600;">15天预报需要开通会员</span>-->
      </div>
      <div class="search_land">
        <input class="search_inp" type="text" placeholder="请输入您想去的岛" @keyup="findIsland" v-model="island" />
        <img src="//images.weelv.com/static/icon/toBottom.png">
      </div>
      <ul v-if="tosearch" class="search_resList">
        <li v-for="item in searchList" :key="item.mddid">
          <div class="search_unit">
            <router-link :to="{ name: 'home', params: { mddid: item.mddid } }">{{ item.name }}</router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {getMddList} from '../api/weather';

  export default {
    name: "Index",
    data() {
      return {
        searchList: [],
        island: '',
        tosearch: false
      };
    },
    methods: {
      findIsland() {
        getMddList(this.island).then(data => {
          if (data.length > 0) {
            this.searchList = data
            this.tosearch = true
          } else {
            this.tosearch = false
          }
        })
      },
    }
  }
</script>

<style scoped>
  @font-face {font-family: 'webfont';
    src: url('//at.alicdn.com/t/webfont_8pycj0lpr0h.eot'); /* IE9*/
    src: url('//at.alicdn.com/t/webfont_8pycj0lpr0h.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('//at.alicdn.com/t/webfont_8pycj0lpr0h.woff') format('woff'), /* chrome、firefox */
    url('//at.alicdn.com/t/webfont_8pycj0lpr0h.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
    url('//at.alicdn.com/t/webfont_8pycj0lpr0h.svg#思源黑体-极细') format('svg'); /* iOS 4.1- */
  }

  .web-font{
    font-family:"webfont" !important;
    font-size: 20px; font-style:normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    height: 100%;
    overflow: hidden;
  }

  .view_bg {
    height: 100%;
    position: relative;
  }

  .view_bg .bg_image{
    display: block;
    width: 100%;
    height: 100%;
  }
  .view_bg .logo_image{
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    z-index: 100;
    width: 68px;
    height: 27px;
  }

  .view_bg .panel{
    width: 100%;
    position: absolute;
    top: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .view_bg .panel .title{
    text-align: center;
    z-index: 100;
    font-size: 26px;
    background: linear-gradient(83deg, rgba(239,210,135,1) 1%, rgba(207,162,87,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 500;
    line-height: 30px;
  }

  .view_bg .panel .search_land{
    position: relative;
    margin: 75px 55px 0 55px;
    width:265px;
    height:45px;
    border:1px solid rgba(224,199,116,1);
    border-radius:5px;
    background: #2e2e30;
    z-index: 3;
  }

  .view_bg .panel .search_land input{
    position: absolute;
    top: 10px;
    left: 20px;
    width: 180px;
    text-align: left;
    font-size:16px;
    font-family:PingFangSC-Light;
    font-weight:300;
    background: none;
    color:rgba(224,199,116,1);
    line-height:18px;
    z-index: 3;
    border: none;
  }

  .view_bg .panel .search_land input::-webkit-input-placeholder {
    color:rgba(224,199,116,1);
  }

  .view_bg .panel .search_land img{
    position: absolute;
    top:20px;
    right: 20px;
    width: 10px;
    height: 5px;
  }

  .view_bg .panel .info{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 25px 0;
  }

  .view_bg .panel .info .sign_info{
    display: block;
    font-size: 34px;
    color: rgba(255, 255, 255, .5);
    position: relative;
    left: -7.5px;
    top: 17.5px;
  }

  .view_bg .panel .info span{
    font-size: 12px;
    line-height: 24px;
    color: rgba(255, 255, 255, .8);
    font-weight: 300;
  }

  .view_bg .panel .search_resList {
    margin: 0 55px;
    margin-top: -5px;
    width: 265px;
    height: 180px;
    overflow-y: scroll;
    border: 1px solid rgba(224,199,116,0.3);
    border-radius: 0 0 5px 5px;
    border-top: 0;
    background: rgba(0,0,0,0.3);
    z-index: 0;
  }

  .view_bg .panel .search_resList .search_unit {
    width: 245px;
    line-height: 45px;
    text-align: left;
    font-size: 14px;
    font-family:PingFangSC-Light;
    font-weight:300;
    color:rgba(224,199,116,1);
    padding:0 10px;
  }

  .view_bg .panel .search_resList .search_unit a {
    color:rgba(224,199,116,1);
    text-decoration: none;
  }
</style>
